import { groupBy, sortBy } from "lodash";

export default {
  updatedAttributes: state => {
    const updatedValues = state.attributes.filter(attr => attr.value !== null);
    if (!updatedValues) {
      return [];
    }

    return updatedValues.reduce((obj, attr) => {
      const gmb_attribute = attr.gmbAttribute || state.availableAttributes.find(
        i => i.attribute_id === attr.attributeId
      );
      const value = attr.value;
      return [
        ...obj,
        {
          gmb_attribute,
          values: Array.isArray(value) ? value : [value],
          google_availability: attr.googleAvailability
        }
      ];
    }, []);
  },

  groupedAttributes: state => query => {
    let filtered = [];
    if (state.attributes) {
      filtered = state.attributes.filter(item => {
        return item.displayName
          .toLowerCase()
          .includes(query.trim().toLowerCase());
      });
    }
    const attributes = sortBy(filtered, "id");
    return {
      items: groupBy(attributes, "groupName"),
      count: attributes.length
    };
  }
};
